<template>
  <!-- start service -->
  <div id="info">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12" style="margin-bottom: 30px;">
          <h1 style="color:#58585a; text-align: center;">Printer Counters</h1>
          <h2 style="color:#58585a; text-align: center;">
            Your advanced Print Counter System for
          </h2>
          <h1 style="color:#58585a; text-align: center;">Network and Local Printers</h1>
        </div>
        <div class="col-md-12 col-sm-12" style="margin-bottom: 30px;">
          <!--<tryBtn></tryBtn>-->
          <tryBtn></tryBtn>
          <gallery :isTop="boolTop" style="padding-top: 50px;"></gallery>
        </div>
        <div class="col-md-12 col-sm-12" v-for="service in services">
          <div class="media" style="padding-left: 10%;">
            <div class="media-object media-left wow fadeInLeft" data-wow-delay="0.2s">
              <!--<i :class="[service.icon]"></i>-->
              <i class="fa fa-diamond"></i>
            </div>
            <div class="media-body wow fadeIn">
              <h3 class="media-heading primary">{{service.title}}</h3>
              <p>{{service.info}}</p>
            </div>
          </div>
        </div>
      </div>
      <tryBtn></tryBtn>
    </div>
  </div>
  <!-- end service -->
</template>
<script>
  import tryBtn from './tryBtn'
  import gallery from './gallery'
  export default {
    name: 'info',
    components: { tryBtn, gallery },
    data () {
      return {
        boolTop: true,
        services: [
          {
            title: 'RealTime Printers Monitoring',
            info: 'Print count information collection from your organization’s printers'
          },
          {
            title: 'Reports',
            info: 'Robust report data that can be used by Managed Print Service companies or by the IT department of your company to track and monitor the status of all printers automatically.'
          },
          {
            title: 'History Log',
            info: 'The Printer Counters Log collects extensive print data history such as number of pages printed or copied (including page size and color information), printer status, toner or ink level, IP address, model, serial number, MAC address.'
          },
          {
            title: 'Customers & Users',
            info: 'Managed Print Service companies can charge their customers based on monthly usage generated reports.'
          },
          {
            title: 'Alerts',
            info: 'Custom rule-based alerts, E-mail alerts, Notification alerts, Error alerts and more!'
          },
          {
            title: 'Dynamic Updates',
            info: 'Clients can be updated remotely to newer versions of the program.'
          },
          {
            title: 'Free 60 days',
            info: ''
          }
        ]
      }
    },
    computed: {
      active () {
        return this.activeMenu === 'HOME'
      }
    }
  }

</script>
<style>
  #info{
    padding-top: 100px;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// info.vue?f6516384